module.exports = __webpack_public_path__ + "static/scale-model-of-public-art-\"ghandig\"-in-pomona-california-9cd5244d3e13c032075fc4d2d10f8807.png";